"use client";

import SectionHeader from "@/components/SectionHeader";
import classes from "./BannersSlider.module.css";

import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import {
  ArrowSquareLeftOutlineIcon,
  ArrowSquareRightOutlineIcon,
} from "@/components/Icons";
import useBrandsById from "@/hooks/useBrandsById";
import { getSectionStyle } from "@/utils";
import { getS3ImageUrl } from "@/utils/routes";
import Image from "next/image";

interface Props {
  sectionHeader?: SectionHeaderType;

  widget?: Widget;
}

const BannersSlider = ({
  sectionHeader,

  widget,
}: Props) => {
  // console.log("BannersSlider widget", widget);
  const { brands, loading, error } = useBrandsById({ widget });

  const randomKey = Math.random().toString(36).substring(7);
  // const randomKey = useMemo(() => Math.random().toString(36).substring(7), [])

  if (!brands?.length) return null;

  // console.log("brands", brands);
  

  const settings = widget?.data?.settings || {};

  return (
    <section
      className={classes.BannersSlider}
      style={getSectionStyle(settings)}
    >
      {sectionHeader && (
        <SectionHeader
          title={sectionHeader.title || ""}
          link={sectionHeader.link}
          btnText={sectionHeader.linkTitle}
        />
      )}
      <div className="container">
        <div className={classes.slider}>
          <div className={classes.changer}>
            <button
              className={`${classes.button} ${classes.left}`}
              id={"swiper-button-prev-banners-slider-" + randomKey}
            >
              <ArrowSquareLeftOutlineIcon className={classes.icon} />
            </button>

            <button
              className={`${classes.button} ${classes.right}`}
              id={"swiper-button-next-banners-slider-" + randomKey}
            >
              <ArrowSquareRightOutlineIcon className={classes.icon} />
            </button>
          </div>

          <Swiper
            spaceBetween={6}
            navigation={{
              nextEl: "#swiper-button-next-banners-slider-" + randomKey,
              prevEl: "#swiper-button-prev-banners-slider-" + randomKey,
            }}
            breakpoints={{
              500: {
                slidesPerView: 2.5,
              },
              800: {
                slidesPerView: 6,
              },
              1200: {
                slidesPerView: 10,
              },
            }}
            slidesPerView={2.5}
            pagination={{
              clickable: true,
            }}
            className={classes.swiper}
            modules={[Navigation]}
            centeredSlides={true}
            initialSlide={Math.floor(brands.length / 2)}
          >
            {brands?.map((product) => (
              <SwiperSlide key={product.id || product.slug || `brand-${product.name}`}>
                <Image
                  className={classes.image}
                  src={getS3ImageUrl(product.logo || "")}
                  alt={(product.name || "brand")+" logo"}
                  unoptimized={true}
                  width={200}
                  height={60}
                  style={{
                    aspectRatio: 200 / 60,
                    objectFit: "contain",
                  }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default BannersSlider;
